import { camelizeKeys } from "humps";
import { isNumber } from "lodash";
import { Id } from "PFTypes/id";

import { createCustomValue, createDictionaryConnection } from "../custom_values";

export const createOrUpdateSkillForProfile = (
  body: {
    created?: boolean;
    global_id?: string | null;
    value?: number | string;
    text?: string;
    source?: string | null;
  } = {},
  id: Id,
  skillsTypeId?: Id
) => {
  if (body.created || !isNumber(id)) {
    const payload = {
      customTypeId: skillsTypeId, // eslint-disable-line camelcase
      value: body.value || body.text,
      globalId: body.global_id // eslint-disable-line camelcase
    };

    return createCustomValue(payload).then((item) => {
      createDictionaryConnection({ customValueId: item.id, ...camelizeKeys(body) });
    });
  } else {
    return createDictionaryConnection({ customValueId: id, ...camelizeKeys(body) });
  }
};
